import script from "./WhosInvolvedAppTable.vue?vue&type=script&setup=true&lang=js"
export * from "./WhosInvolvedAppTable.vue?vue&type=script&setup=true&lang=js"

import "./WhosInvolvedAppTable.vue?vue&type=style&index=0&id=7ac41f19&scoped=true&lang=css"

import exportComponent from "/Users/jwmoreland/Documents/_Develop/HIRC Website/wp-content/themes/hirc-custom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ac41f19"]])

export default __exports__